import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/login-image.webp'


const _hoisted_1 = { class: "min-h-full flex" }
const _hoisted_2 = { class: "flex-1 flex flex-col justify-center py-12 px-4 bg-white sm:px-6 lg:flex-none lg:px-20 xl:px-24" }
const _hoisted_3 = { class: "mx-auto w-full max-w-sm lg:w-96" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "mt-6" }
const _hoisted_6 = {
  action: "#",
  method: "POST",
  class: "space-y-6"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-sm font-medium text-gray-700"
}, " Eメール ", -1)
const _hoisted_8 = { class: "mt-1" }
const _hoisted_9 = { class: "space-y-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "block text-sm font-medium text-gray-700"
}, " パスワード ", -1)
const _hoisted_11 = { class: "mt-1" }
const _hoisted_12 = { class: "flex items-center justify-between" }
const _hoisted_13 = { class: "text-sm" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "email-error"
}
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-6 relative\"><div class=\"absolute inset-0 flex items-center\" aria-hidden=\"true\"><div class=\"w-full border-t border-gray-300\"></div></div><div class=\"relative flex justify-center text-sm\"><span class=\"px-2 bg-white text-gray-500\">アカウントをお持ちでない方</span></div></div>", 1)
const _hoisted_17 = { class: "mt-8" }
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-6 relative\"><div class=\"absolute inset-0 flex items-center\" aria-hidden=\"true\"><div class=\"w-full border-t border-gray-300\"></div></div><div class=\"relative flex justify-center text-sm\"><span class=\"px-2 bg-white text-gray-500\">SNSのアカウントでログイン</span></div></div>", 1)
const _hoisted_19 = { class: "mt-8" }
const _hoisted_20 = ["href"]
const _hoisted_21 = ["href"]
const _hoisted_22 = ["href"]
const _hoisted_23 = ["href"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "hidden lg:block relative w-0 flex-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "absolute inset-0 h-full w-full object-cover",
    src: _imports_0
  })
], -1)

import * as yup from "yup";
import { useField, useForm, FieldContext } from "vee-validate";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Auth } from "aws-amplify";
import { computed, onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const store = useStore();
//const router = useRouter();

const formSchema = yup.object({
  email: yup.string().email().required("必須項目です"),
  password: yup.string(),
  new_password: yup.string(),
});

useForm({ validationSchema: formSchema });

const email_field = useField<string>("email");
const password_field = useField<string>("password");
const new_password_field = useField<string>("new_password");

const email = email_field.value;
const email_error = email_field.errorMessage;

const password = password_field.value;
const password_error = password_field.errorMessage;

const new_password = new_password_field.value;
const new_password_error = new_password_field.errorMessage;

const login_result = ref<any>();
const mode = ref<string>("signin");
const message = ref<string>("");

const facebookSignInUrl = computed<string>(() => {
  return `https://terraspace-prod.auth.ap-northeast-1.amazoncognito.com/oauth2/authorize?identity_provider=Facebook&redirect_uri=http://localhost:8080/oauth/facebook/callback&response_type=CODE&client_id=${process.env.VUE_APP_AWS_COGNITO_CLIENT_ID}`;
});

const googleSignInUrl = computed<string>(() => {
  return `https://terraspace-prod.auth.ap-northeast-1.amazoncognito.com/oauth2/authorize?identity_provider=Google&redirect_uri=http://localhost:8080/oauth/google/callback&response_type=CODE&client_id=${process.env.VUE_APP_AWS_COGNITO_CLIENT_ID}`;
});

const lineSignInUrl = computed<string>(() => {
  return `https://terraspace-prod.auth.ap-northeast-1.amazoncognito.com/oauth2/authorize?identity_provider=LINE&redirect_uri=http://localhost:8080/oauth/facebook/callback&response_type=CODE&client_id=${process.env.VUE_APP_AWS_COGNITO_CLIENT_ID}`;
});

const appleSignInUrl = computed<string>(() => {
  return `https://terraspace-prod.auth.ap-northeast-1.amazoncognito.com/oauth2/authorize?identity_provider=SignInWithApple&redirect_uri=http://localhost:8080/oauth/apple/callback&response_type=CODE&client_id=${process.env.VUE_APP_AWS_COGNITO_CLIENT_ID}`;
});

// onMounted(async () => {
//   const decedent_id = "207e41d1-201a-48ea-a548-19bff818d108";
//   // 207e41d1-201a-48ea-a548-19bff818d108
//   guestLogin(decedent_id);
// });

const validateLogin = async (): Promise<boolean> => {
  await email_field.validate();
  await password_field.validate();

  return !email_error.value && !password_error.value;
};

const doLogin = () => {
  // console.log(`doLogin(${email.value}, ${password.value})`);

  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const valid = await validateLogin();
      if(!valid) {
        return;
      }

      login_result.value = await Auth.signIn(email.value, password.value);
      // console.log(login_result.value);

      if (login_result.value.challengeName == "NEW_PASSWORD_REQUIRED") {
        mode.value = "new_password";
      }
    } catch (ex) {
      const errorMessage = `${ex}`;
      // console.log(errorMessage);

      if (errorMessage.startsWith("NotAuthorizedException")) {
        message.value = "ログインに失敗しました";
      }
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const doComplateNewPassword = () => {
  // console.log(`doComplateNewPassword(${new_password.value})`);

  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const newpassword_result = await Auth.completeNewPassword(
        login_result.value,
        new_password.value
      );
      // console.log(newpassword_result);
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const clearError = () => {
  message.value = "";
};

// const guestLogin = (decedent_id) => {
//   store.dispatch("markShownVideo", true);
//   store.dispatch("setLoading", true);
//   setTimeout(async () => {
//     try {
//       login_result.value = await Auth.signIn(`rimoku@hasema-system.com`, `uyVEaXpaysLV`);
//     } catch (ex) {
//       const errorMessage = `${ex}`;
//       // console.log(errorMessage);

//       router.replace('/decedents/' + decedent_id);

//       if (errorMessage.startsWith("NotAuthorizedException")) {
//         message.value = "ログインに失敗しました";
//       }
//     } finally {
//       store.dispatch("setLoading", false);
//     }
//   });
// };

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: require('@/assets/images/logo_large.png'),
            class: "h-8"
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", _hoisted_6, [
            _createElementVNode("div", null, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  autocomplete: "email",
                  required: "",
                  class: "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : null))
                }, null, 512), [
                  [_vModelText, _unref(email)]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  autocomplete: "current-password",
                  required: "",
                  class: "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(password) ? (password).value = $event : null))
                }, null, 512), [
                  [_vModelText, _unref(password)]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_router_link, {
                  to: `/reset`,
                  class: "font-medium text-indigo-600 hover:text-indigo-500"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" パスワードをお忘れの方 ")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-color-2",
                onClick: _withModifiers(doLogin, ["prevent"])
              }, " ログイン ", 8, _hoisted_14),
              (!!message.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(message.value), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", null, [
            _createVNode(_component_router_link, {
              to: `/signup`,
              class: "w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-color-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 新規登録 ")
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", null, [
            _createElementVNode("p", null, [
              _createElementVNode("a", {
                class: "px-7 py-3 text-white font-medium text-sm leading-snug uppercase rounded shadow-md hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg transition duration-150 ease-in-out w-full flex justify-center items-center mb-3",
                style: {"background-color":"#3b5998"},
                href: facebookSignInUrl.value,
                role: "button",
                "data-mdb-ripple": "true",
                "data-mdb-ripple-color": "light"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-brands fa-facebook",
                  class: "mr-2"
                }),
                _createTextVNode(" Facebookでログイン ")
              ], 8, _hoisted_20)
            ]),
            _createElementVNode("p", null, [
              _createElementVNode("a", {
                class: "px-7 py-3 text-gray-800 font-medium text-sm leading-snug uppercase rounded shadow-md hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg transition duration-150 ease-in-out w-full flex justify-center items-center mb-3",
                style: {"background-color":"white"},
                href: googleSignInUrl.value,
                role: "button",
                "data-mdb-ripple": "true",
                "data-mdb-ripple-color": "light"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-brands fa-facebook",
                  class: "mr-2"
                }),
                _createTextVNode(" Googleでログイン ")
              ], 8, _hoisted_21)
            ]),
            _createElementVNode("p", null, [
              _createElementVNode("a", {
                class: "px-7 py-3 text-white font-medium text-sm leading-snug uppercase rounded shadow-md hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg transition duration-150 ease-in-out w-full flex justify-center items-center mb-3",
                style: {"background-color":"#55b936"},
                href: lineSignInUrl.value,
                role: "button",
                "data-mdb-ripple": "true",
                "data-mdb-ripple-color": "light"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-brands fa-line",
                  class: "mr-2"
                }),
                _createTextVNode(" LINEでログイン ")
              ], 8, _hoisted_22)
            ]),
            _createElementVNode("p", null, [
              _createElementVNode("a", {
                class: "px-7 py-3 text-gray-800 font-medium text-sm leading-snug uppercase rounded shadow-md hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg transition duration-150 ease-in-out w-full flex justify-center items-center mb-3",
                style: {"background-color":"white"},
                href: appleSignInUrl.value,
                role: "button",
                "data-mdb-ripple": "true",
                "data-mdb-ripple-color": "light"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-brands fa-apple",
                  class: "mr-2"
                }),
                _createTextVNode(" Sign In With Apple ")
              ], 8, _hoisted_23)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_24
  ]))
}
}

})